import { selectorFamily } from "recoil";

import { ViewDto } from "../../dto";
import { Log, resolveDefaultView } from "../../helpers";
import { RydeUiUnit, TFinalSchemaInitState } from "../../models";
import {
  activeViewIdAtomFamily,
  finalSchemaInitStateAF,
  profileDtoAtom,
  profileScopeAtom,
  viewDtosAtomFamily,
} from "../atoms";

export const defaultViewSF = selectorFamily<ViewDto | undefined, RydeUiUnit>({
  key: "defaultViewSF",
  get:
    entity =>
    ({ get }) => {
      const viewDtos = get(viewDtosAtomFamily(entity));
      const profileScope = get(profileScopeAtom);
      const profile = get(profileDtoAtom);
      const defaultView = resolveDefaultView({
        viewDtos,
        companyId: profileScope?.companyId,
        userId: profile?.id,
      });
      Log.debug(`Default view for entity ${entity}`, defaultView, viewDtos);
      return defaultView;
    },
});

export const activeViewSF = selectorFamily<ViewDto | undefined, RydeUiUnit>({
  key: "activeViewSF",
  get:
    entity =>
    ({ get }) => {
      const viewDtos = get(viewDtosAtomFamily(entity));
      const activeViewId = get(activeViewIdAtomFamily(entity));

      if (!activeViewId) {
        return undefined;
      }

      const activeView = viewDtos?.find(v => v.id === activeViewId);

      return activeView;
    },
});

export const isViewLoadedSF = selectorFamily<boolean, RydeUiUnit>({
  key: "isViewLoadedSF",
  get:
    entity =>
    ({ get }) => {
      const viewDtos = get(viewDtosAtomFamily(entity));
      return viewDtos !== undefined;
    },
});

export const finalSchemaInitStateSF = selectorFamily<
  TFinalSchemaInitState,
  RydeUiUnit
>({
  key: "finalSchemaInitStateSF",
  get:
    entity =>
    ({ get }) => {
      const finalSchemaInitState = get(finalSchemaInitStateAF(entity));
      return finalSchemaInitState;
    },
});
